import { useState, useEffect } from "react";
import { TrendingUp, TrendingDown } from "lucide-react";

interface TickerItem {
  label: string;
  value: string;
  change: string;
  up: boolean;
}

const FALLBACK_DATA: TickerItem[] = [
  { label: "Brent Crude", value: "$70.45", change: "+0.1%", up: true },
  { label: "WTI", value: "$65.27", change: "+0.1%", up: true },
  { label: "Natural Gas", value: "$3.00", change: "-0.4%", up: false },
  { label: "Heating Oil", value: "$2.43", change: "-3.4%", up: false },
  { label: "Gasoline RBOB", value: "$2.21", change: "+12.4%", up: true },
  { label: "Gold", value: "$5,017.00", change: "+0.6%", up: true },
  { label: "Silver", value: "$77.99", change: "+0.6%", up: true },
  { label: "Copper", value: "$5.79", change: "-0.1%", up: false },
  { label: "Platinum", value: "$2,090.50", change: "-0.8%", up: false },
  { label: "Wheat", value: "$555.75", change: "+1.6%", up: true },
  { label: "Corn", value: "$427.50", change: "+0.1%", up: true },
  { label: "Coffee", value: "$285.20", change: "-0.8%", up: false },
];

const MarketTicker = () => {
  const [data, setData] = useState<TickerItem[]>(FALLBACK_DATA);

  useEffect(() => {
    const fetchPrices = async () => {
      try {
        const res = await fetch(
          `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/market-prices`,
          {
            headers: {
              Authorization: `Bearer ${import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY}`,
            },
          }
        );
        if (!res.ok) throw new Error("Failed to fetch prices");
        const json = await res.json();
        if (json.items && json.items.length > 0) {
          setData(json.items);
        }
      } catch (err) {
        console.error("Market ticker fetch error:", err);
        // Keep fallback data
      }
    };

    fetchPrices();
    // Refresh every 2 minutes
    const interval = setInterval(fetchPrices, 2 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const items = [...data, ...data];

  return (
    <div className="bg-ticker border-b border-divider overflow-hidden">
      <div className="flex animate-ticker whitespace-nowrap py-2.5">
        {items.map((item, i) => (
          <div key={i} className="flex items-center gap-1.5 px-5 border-r border-divider">
            <span className="text-xs text-muted-foreground font-medium">{item.label}</span>
            <span className="text-xs font-mono font-medium text-foreground">{item.value}</span>
            <span className={`text-xs font-mono flex items-center gap-0.5 ${item.up ? "text-emerald-400" : "text-red-400"}`}>
              {item.up ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
              {item.change}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MarketTicker;
